module.exports = __webpack_public_path__ + "860e70b9e948cd9d84dcd0d3753ee367.jpg";